import { api as axios } from '@/plugins/axios';

export const getRecentAlerts = async (token, params) => {
  const config = {
    method: 'get',
    url: '/v2/alerts/recent',
    headers: {
      'Authorization': 'Bearer ' + token,
    },
    params,
  };
  const { data } = await axios(config);
  return data;
};
